/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { IFramePreviewPanel } from './common/IFramePreviewPanel';

type Props = {
	name: string;
	url: string;
	iconUrl?: string;
};

const styles = cssMap({
	icon: {
		width: '16px',
		height: '16px',
	},
});

export const JiraIssuePreviewPanel = memo(({ name, url, iconUrl }: Props) => (
	<IFramePreviewPanel
		name={name}
		url={url}
		iframeUrl={`${url}/embed`}
		icon={iconUrl ? <img src={iconUrl} alt="" css={styles.icon} /> : undefined}
	/>
));
